import { AxiosResponse } from 'axios';
import { apiClient } from '../instance';
import { Issue, IssueFetchedAttachment } from '../../types/issueInterfaces';
import { IFilters } from '@entities/issue/model';

const checkFiltersStatusCodes = (
  value: string | { value: string; label: string }
) => {
  if (typeof value !== 'string') {
    if (value) {
      return value.value;
    }
  }
  return null;
};

export const issuesApi = {
  getIssues: (): Promise<AxiosResponse<Issue[]>> => {
    return apiClient.get<Issue[]>('/issue/');
  },
  getFilteredIssues: (
    filters: IFilters,
    page: number
  ): Promise<AxiosResponse<Issue[]>>[] => {
    // Общие query-параметры. Раньше они дублировались в двух
    // вызовах apiClient.get(...) — пришлось бы добавлять
    // company_ids в обоих. Вынес в отдельный объект, чтобы было
    // невозможно забыть прокинуть фильтр в одном из них.
    const baseParams: Record<string, unknown> = {
      created_since: filters.startDate,
      created_until: filters.endDate,
      // issue_ids: Boolean(filters.query) ? filters.query : null,
      status_codes: checkFiltersStatusCodes(filters.status),
      page_size: 10,
      type_codes: 'Reclamation',
    };
    // Multi-select по компаниям (только для staff). DRF-сериализатор
    // принимает ListField → axios сам разворачивает массив в
    // ?company_ids=1&company_ids=2.
    if (filters.companyIds && filters.companyIds.length > 0) {
      baseParams.company_ids = filters.companyIds;
    }
    // indexes: null → массивы кодируются повторяющимся ключом без
    // скобок (company_ids=1&company_ids=2). Дефолтный axios-сериализатор
    // ставит `company_ids[]=…`, а DRF-сериализатор OkdeskIssueListFilters
    // читает плоский ключ `company_ids` — из-за скобок значение терялось,
    // и фильтр по компании у менеджеров молча не применялся.
    const paramsSerializer = { indexes: null } as const;
    const response = apiClient.get<Issue[]>('/issue/', {
      params: { ...baseParams, page_number: page },
      paramsSerializer,
    });
    const checkNextPage = apiClient.get<Issue[]>('/issue/', {
      params: { ...baseParams, page_number: page + 1 },
      paramsSerializer,
    });
    return [response, checkNextPage];
  },
  getIssueById: (id: number): Promise<AxiosResponse<Issue>> => {
    return apiClient.get<Issue>(`/issue/${id}`);
  },
  postCommentOnIssue: (id: number, data: any) => {
    return apiClient.post(`/issue/${id}/comment/`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getIssueAttachment: (ids: {
    issueId: number;
    attachmentId: number;
  }): Promise<AxiosResponse<IssueFetchedAttachment>> => {
    return apiClient.get(
      `issue/${ids.issueId}/attachment/${ids.attachmentId}/`
    );
  },
};
